import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

import { EmpresaProvider } from '../empresa';
import { FiltroFechaProvider } from '../filtroFecha';
import { EmpresaSelector } from '../components';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

const { Header, Sider, Content } = Layout;

export function AppLayout() {
  return (
    <EmpresaProvider>
      <FiltroFechaProvider>
        <Layout style={{ minHeight: '100vh' }}>
          <Sider width={240} breakpoint="md" collapsedWidth={64}>
            <div style={{
              padding: '20px 16px',
              textAlign: 'center',
              borderBottom: '1px solid rgba(255,255,255,0.08)',
            }}>
              <img
                src="/logo-asicontadores-white.png"
                alt="ASI Contadores"
                style={{ height: 100, width: 'auto' }}
              />
            </div>
            <Sidebar />
          </Sider>

          <Layout>
            <Header style={{
              padding: '0 24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderBottom: '1px solid #f0f0f0',
            }}>
              <EmpresaSelector />
              <Topbar />
            </Header>

            <Content style={{ margin: 24 }}>
              <Outlet />
            </Content>
          </Layout>
        </Layout>
      </FiltroFechaProvider>
    </EmpresaProvider>
  );
}
